// React
import { memo, useCallback, useRef, useState } from "react";

// UI
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalBody from "ui/components/Modal/ModalBody";
import ModalFooter from "ui/components/Modal/ModalFooter";
import ModalHeader from "ui/components/Modal/ModalHeader";

import InvoiceIncomingItemsAllocation from "../InvoiceIncomingItemsAllocation/InvoiceIncomingItemsAllocation";
import {
  InvoiceIncomingItemsAllocationRef,
  InvoiceIncomingItemsAllocationState,
} from "../InvoiceIncomingItemsAllocation/types";
import { INITIAL_ALLOCATION_STATE } from "./consts";
import { InvoiceIncomingAllocationModalProps } from "./types";

/**
 * Nakon odobrenja računa troškovi se moraju negdje knjižiti, pa se raspodjela nudi odmah —
 * isti raspored dostupan je i preko gumba „Raspodjeli troškove".
 */
const InvoiceIncomingAllocationModal: React.FC<InvoiceIncomingAllocationModalProps> = (props) => {
  const { show, invoiceId, invoiceNumber, items, defaultVehicleId, onHide, onSuccess } = props;

  const allocationRef = useRef<InvoiceIncomingItemsAllocationRef>(null);
  const [state, setState] = useState<InvoiceIncomingItemsAllocationState>(INITIAL_ALLOCATION_STATE);

  const handleStateChange = useCallback((next: InvoiceIncomingItemsAllocationState) => {
    setState(next);
  }, []);

  const handleSaveClick = useCallback(() => {
    allocationRef.current?.submit();
  }, []);

  return (
    <Modal show={show} onHide={onHide} position="centered" size="medium">
      <ModalHeader
        icon="/media/images/add-icon.svg"
        title={`Raspodjela troškova ${invoiceNumber ?? ""}`.trim()}
        onHide={onHide}
      />
      <ModalBody>
        {show && (
          <div className="px-5 pt-4 pb-5">
            <InvoiceIncomingItemsAllocation
              ref={allocationRef}
              invoiceId={invoiceId}
              items={items}
              defaultVehicleId={defaultVehicleId}
              onSuccess={onSuccess}
              onStateChange={handleStateChange}
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="px-4 py-3 flex justify-between gap-3">
          <Button variant="outlined" children="Preskoči" onClick={onHide} />
          <Button
            variant="primary"
            children={`Spremi raspored (${state.allocated}/${state.total})`}
            onClick={handleSaveClick}
            disabled={state.isSaving || state.allocated === 0 || state.hasErrors}
          />
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default memo(InvoiceIncomingAllocationModal);
